var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    model: _vm.form,
                    size: "small",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.month,
                          valueformat: "yyyyMM",
                          type: "month",
                          clearable: false,
                          editable: false,
                          placeholder: _vm.$t(
                            "storeComponents.common.pleaseSelectMonth"
                          ),
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "month", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "light-blue-board mt_20" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("dashboard.activeStoreTarget"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "values" }, [
            _c("div", { staticClass: "nums" }, [
              _c("span", { staticClass: "num1 blue" }, [
                _vm._v(
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.activeCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.activeCount)
                  )
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "space" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", { staticClass: "num2" }, [
                _vm._v(
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.activeTargetCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.activeTargetCount)
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.activeTargetCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.activeTargetRate)
                  ) +
                  "%\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("el-progress", {
            attrs: {
              percentage:
                _vm.sourceData.activeTargetRate > 100
                  ? 100
                  : _vm.sourceData.activeTargetRate,
              color: "#004EA8",
              "show-text": false,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "light-blue-board mt_20" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("dashboard.signStoreTarget"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "values" }, [
            _c("div", { staticClass: "nums" }, [
              _c("span", { staticClass: "num1 blue" }, [
                _vm._v(
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.signingCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.signingCount)
                  )
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "space" }, [_vm._v("/")]),
              _vm._v(" "),
              _c("span", { staticClass: "num2" }, [
                _vm._v(
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.signingTargetCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.signingTargetCount)
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.paddingNum(_vm.sourceData.signingTargetCount) == 0
                      ? "-"
                      : _vm.paddingNum(_vm.sourceData.signingRate)
                  ) +
                  "%\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("el-progress", {
            attrs: {
              percentage:
                _vm.sourceData.signingRate > 100
                  ? 100
                  : _vm.sourceData.signingRate,
              color: "#004EA8",
              "show-text": false,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt_20", attrs: { gutter: 10 } },
        [
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "light-blue-board" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.monthRegistered"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "values" }, [
                _c("div", { staticClass: "nums" }, [
                  _c("span", { staticClass: "num1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.paddingNum(_vm.sourceData.monthlyRegistered) == 0
                          ? "-"
                          : _vm.paddingNum(_vm.sourceData.monthlyRegistered)
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "light-blue-board" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.annuallyRegistered"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "values" }, [
                _c("div", { staticClass: "nums" }, [
                  _c("span", { staticClass: "num1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.paddingNum(_vm.sourceData.annuallyRegistered) == 0
                          ? "-"
                          : _vm.paddingNum(_vm.sourceData.annuallyRegistered)
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 8 } }, [
            _c("div", { staticClass: "light-blue-board" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("dashboard.allRegistered"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "values" }, [
                _c("div", { staticClass: "nums" }, [
                  _c("span", { staticClass: "num1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.paddingNum(_vm.sourceData.registered) == 0
                          ? "-"
                          : _vm.paddingNum(_vm.sourceData.registered)
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _c("i", { staticClass: "el-icon-warning-outline" }),
        _vm._v(_vm._s(_vm.$t("dashboard.storeAllTip"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }